import React, {Fragment, useEffect, useReducer, useState} from 'react';

import SpinnerDiv from "ui/SpinnerDiv";

import { getSchool } from "root/DataFunctions/SchoolDataFns";

import {getCustomDataFromResponse, getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import {Tabs, Tab} from "react-bootstrap";

import TableTeachers from "./TableTeachers";
import TablePupils from "./TablePupils";

import './SchoolDetailForm.scss';
import TableAttendanceOfficers from "root/School/TableAttendanceOfficers";
import SchoolEditForm from "root/School/ReactSchoolEditForm";
import useModalComponent from "root/Modals/useModalComponent";
import ModalSchool from "root/Modals/ModalSchool/ModalSchool";
import BootstrapRow from "ui/BootstrapRow";

const SchoolDetailForm = ( props ) =>
{
	const [data, setData] = useState({loading: true, data: [], teachers: [], pupils: []});

	const [ renderModal, showSchoolModal ] = useModalComponent( ModalSchool );

	useEffect(() =>
	{
		refreshSchool() ;
	}, []);

	const refreshSchool = () =>
	{
		getSchool ( props.school_id, ( response ) =>
		{
			const data = getDataFromResponse( response );

			const custom = getCustomDataFromResponse( response ) ;
			const teachers = custom?.teachers === undefined ? [] : custom.teachers ;
			const attendance_officers = custom?.attendance_officers === undefined ? [] : custom.attendance_officers ;

			const pupils = custom?.pupils === undefined ? [] : custom.pupils ;

			setData( { loading: false, data: data, teachers: teachers, pupils: pupils, attendance_officers: attendance_officers }) ;
		}) ;

	}

	const schoolDetailHeader = () =>
	{
		return <SchoolEditForm
			school={data.data[0]}
			showButtons={false}
			mode='view'
			displayMode='form'
			displayGroups={false}
			passwordRequired={false}
			return_url={null}
			key='SchoolDetail' />
	}

	const SchoolDetailTabs = () =>
	{
		return (
			<Fragment>
				{schoolDetailHeader()}
				<Tabs defaultActiveKey="teachers" id="teachers-tab" className="mb-3">
					<Tab eventKey="teachers" title="Teachers">
						<TableTeachers loading={data.loading} data={data.teachers} />
					</Tab>
					<Tab eventKey="aofficers" title="Attendance Officers">
						<TableAttendanceOfficers loading={data.loading} data={data.attendance_officers} />
					</Tab>
					<Tab eventKey="pupils" title="Pupils">
						<TablePupils loading={data.loading} data={data.pupils} />
					</Tab>
				</Tabs>
			</Fragment>
		)
	}

	const onEditSchoolClick = () =>
	{
		showSchoolModal ( { school_id: props.school_id, mode: 'edit' } ).then((result) => {
			if (result !== 'cancel')
			{
				refreshSchool();
			}
		});
	}

	const editSchoolButtonRow = () =>
	{
		return (
			<BootstrapRow>
				<div className='col-md-12' style={{marginTop: '15px'}}>
					<button className='btn btn-sm btn-info' onClick={onEditSchoolClick}><span className='glyphicons glyphicons-pencil'>Edit School Details</span></button>
				</div>
			</BootstrapRow>
		)
	}

	const RenderedPage = () =>
	{
		return (
			<Fragment>
				<div className='panel panel-default panel-base'>
					<SchoolDetailTabs/>
					{editSchoolButtonRow()}
				</div>
				{renderModal()}
			</Fragment>
		)
	}

	return (
		<div className="jumbotron">
			<p className="med">View School</p>
			{ data.loading === true && <SpinnerDiv/> }
			{ data.loading !== true && <RenderedPage/> }
		</div>
	)
}

export default SchoolDetailForm ;
